import { Link } from "react-router-dom";
import { C, font } from "../tokens";

/**
 * Botão CTA padrão.
 *
 * Props:
 *   children         label
 *   primary          true (accent) | false (outline branco)
 *   to               rota react-router (ex: "/agendar-demo")
 *   href             link externo / âncora (#demo) — usado se `to` não for passado
 *   light            quando true em primary=false, usa contorno branco (para fundo escuro)
 *   onClick          handler opcional
 *   style            override
 */
export default function CtaButton({
  children,
  primary = true,
  to,
  href,
  light = false,
  onClick,
  style = {},
}) {
  const outlineColor = light ? "white" : C.primary;
  const outlineText = light ? "white" : C.primary;

  const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "13px 26px",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 700,
    textDecoration: "none",
    fontFamily: font,
    background: primary ? C.accent : (light ? "transparent" : "white"),
    color: primary ? "white" : outlineText,
    border: primary ? "none" : `2px solid ${outlineColor}`,
    transition: "all 0.15s",
    cursor: "pointer",
    ...style,
  };

  if (to) {
    return (
      <Link to={to} style={baseStyle} onClick={onClick}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href || "#"} style={baseStyle} onClick={onClick}>
      {children}
    </a>
  );
}
